import { QuickTable, QuickTableFilterTabs } from "../../components";
import { CreateTopUp } from "./CreatePayOuts";
import { topUpsDisplayFormatter } from "./payOutsDisplayFormatter";
import { IPaymentViewProps } from "./PayOuts";

export const View = (props: IPaymentViewProps) => {
  return (
    <>
      <QuickTable
        id="paymentsTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={topUpsDisplayFormatter}
        onExport={props.onExport}
        onCreateNew={props.onCreateNew}
      />

      <CreateTopUp
        isModalOpen={props.isCreateNewModalOpen}
        closeModal={props.closeModal}
      />
    </>
  );
};
